import { render, staticRenderFns } from "./PointListWithdrawLayout.vue?vue&type=template&id=4446212b&scoped=true&"
import script from "./PointListWithdrawLayout.vue?vue&type=script&lang=js&"
export * from "./PointListWithdrawLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446212b",
  null
  
)

export default component.exports